var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card custom" },
    [
      _c("ValidationObserver", {
        ref: "observer",
        attrs: { tag: "form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ valid }) {
              return [
                _c("header", { staticClass: "modal-card-head" }, [
                  _c("p", { staticClass: "modal-card-title" }, [
                    _vm._v(
                      " " + _vm._s(_vm.role ? "Edit role" : "Create role") + " "
                    ),
                  ]),
                ]),
                _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "name" } },
                      [
                        _c("ValidationProvider", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("b-input", {
                                      attrs: {
                                        name: "name",
                                        type: "text",
                                        pattern: "[a-zA-Z0-9 ]+",
                                        required: "",
                                      },
                                      model: {
                                        value: _vm.roleToEdit.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.roleToEdit, "name", $$v)
                                        },
                                        expression: "roleToEdit.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm.role
                      ? _c(
                          "b-tabs",
                          {
                            staticClass: "rights",
                            attrs: { type: "is-toggle", expanded: "" },
                          },
                          _vm._l(_vm.parentRights, function (parent) {
                            return _c(
                              "b-tab-item",
                              { key: parent.id, attrs: { label: parent.name } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    class: {
                                      "is-primary": !!parent.authorized,
                                      "is-danger": !parent.authorized,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeValue(parent.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          !!parent.authorized
                                            ? "Activé"
                                            : "Désactivé"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "children-rights",
                                    class: {
                                      "children-rights-disabled":
                                        !parent.authorized,
                                    },
                                  },
                                  _vm._l(
                                    _vm.getChildrens(parent.id),
                                    function (children) {
                                      return _c(
                                        "div",
                                        {
                                          key: children.id,
                                          staticClass: "hero",
                                          class: {
                                            "is-primary": children.authorized,
                                            "is-white": !children.authorized,
                                          },
                                          on: {
                                            click: function ($event) {
                                              parent.authorized
                                                ? _vm.changeValue(children.id)
                                                : null
                                            },
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              " " + _vm._s(children.name) + " "
                                            ),
                                            children.description
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "is-pulled-right",
                                                  },
                                                  [
                                                    _c(
                                                      "b-tooltip",
                                                      {
                                                        attrs: {
                                                          label:
                                                            children.description,
                                                          type: "is-dark",
                                                          multilined: "",
                                                          position: "is-left",
                                                        },
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon: "info",
                                                            type: "is-link",
                                                            size: "is-small",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("footer", { staticClass: "modal-card-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "is-primary button is-fullwidth",
                      class: { "is-loading": _vm.isSubmitting || _vm.loading },
                      attrs: { type: "submit" },
                    },
                    [_vm._v(" Submit ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }